app.service('searchShopMap', function(broker, searchShopDetails, front) {
	let gmap;
	let markers = [];
	let markerCluster = null;
	let activeShop = null;

	function createMarker (item) {
		var options =	{
			map: gmap,
			position: { lat: +item.location.ltd, lng: +item.location.lgt },
			title: item.city,
			icon: getIcon(),
			id: item.code
		};
		return new google.maps.Marker( options );
	}

	function panToBounds (shops) {
		const bounds = new google.maps.LatLngBounds();
		shops.forEach(shop =>
			bounds.extend({ lat: +shop.location.ltd, lng: +shop.location.lgt })
		);
		gmap.fitBounds( bounds );
	}

	function clearMarkers () {
		setMapOnAll(null);
		markers = [];
		if(markerCluster) {
			markerCluster.clearMarkers();
		}
	}

	function setMapOnAll (map) {
		for (var i = 0; i < markers.length; i++) {
			markers[i].setMap(map);
		}
	}

	function addMarkerClickEventListener (marker) {
		google.maps.event.addListener(marker, 'click', function() {
			broker.trigger( 'SEARCH_SHOP_MARKER_CLICK', [marker.id] );
		});
	}

	function updateMap (shops) {
		clearMarkers();
		shops.forEach((item, i) => {
			const marker = createMarker(item);
			markers.push(marker);
			addMarkerClickEventListener(marker);
		});
		panToBounds(shops);
		markerCluster = new MarkerClusterer(gmap, markers, {
			styles: [{
				url: getIcon(),
				width: 20,
				height: 33,
				textSize: 14
			}]
		});
	}

	function getIcon () {
		return '/img/desktop/' + front.name() + '/marker-ico.png';
	}

	function setEvents () {
		document.onwebkitfullscreenchange = () => {
			if (activeShop) {
				setTimeout(() => panToLocation(activeShop), 100);
			}
		};
		document.onmozfullscreenchange = () => {
			if (activeShop) {
				setTimeout(() => panToLocation(activeShop), 100);
			}
		}
		broker.on('SEARCH_SHOP_DISPLAY_SHOPS', (event, shops) => {
			updateMap(shops);
		});
		broker.on('SEARCH_SHOP_INIT', (event, shops) => {
			updateMap(shops)
		});
		broker.on('SEARCH_SHOP_PAN_TO', (event, shop) => {
			activeShop = shop;
			panToLocation(shop);
		});
	}

	function panToLocation(shop) {
		const marker = markers.filter(marker => marker.id === shop.code)[0];
		searchShopDetails.show(shop);
		gmap.panTo(marker.getPosition());
		gmap.setZoom(17);
	}

	function init () {
		const center = {lat: 51.9614997, lng: 18.11389};
		gmap = new google.maps.Map( $('#map')[0], {
			center,
			zoom: 6,
			maxZoom: 17,
			streetViewControl: false,
			mapTypeControl: false,
			gestureHandling: 'greedy'
		});
		searchShopDetails.init(gmap);
		setEvents();
	}

	return {
		init
	};
});